import TaxonomyTerm from "../../types/TaxonomyTerm";
import { TaxonomyAction, TaxonomyState } from "./TaxonomyState";

export const DISPATCH = 'WIS/taxonomy/opportunities/DISPATCHED';
export const FULFILL = 'WIS/taxonomy/opportunities/FULFILLED';
export const REJECT = 'WIS/taxonomy/opportunities/REJECTED';

export type OpportunitiesActionTypes = 
  'WIS/taxonomy/opportunities/DISPATCHED'
  | 'WIS/taxonomy/opportunities/FULFILLED'
  | 'WIS/taxonomy/opportunities/REJECTED';

export const dispatch = () => ({ type: DISPATCH });
export const fulfill = (payload: TaxonomyTerm[]) => ({ type: FULFILL, payload });
export const reject = (error: string) => ({ type: REJECT, error });

const initialState: TaxonomyState = {
  terms: [],
  isFetching: false,
  isFetched: false,
  error: null,
};

export type TaxonomyOpportunitiesAction = TaxonomyAction<OpportunitiesActionTypes>;

export default function reducer(state = initialState, action: TaxonomyOpportunitiesAction) {
  switch (action.type) {
    case DISPATCH:
      return {
        ...state,
        isFetching: true,
      };

    case FULFILL:
      return {
        ...state,
        terms: action.payload,
        isFetching: false,
        isFetched: true,
        error: null,
      };

    case REJECT:
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };

    default:
      return state;
  }
}
